// extracted by mini-css-extract-plugin
module.exports = {"monogram":"Monogram_monogram__tnGpV","highlight":"Monogram_highlight__ly_rQ"};